/**
 * Wrapper around persistent storage interfaces
 * @module
 */

var KEY = 'optimizely_data';

var createError = require('../utils/custom_error').create;
var StorageFactory = require('../lib/storage_factory');
var WindowEnv = require('./window');

var StorageError = exports.Error = createError('StorageError');

var storageWrapper;
var localStorage:Storage;

try {
  localStorage = WindowEnv.getGlobal('localStorage');
} catch(e) {
  throw new StorageError('Unable to read localStorage: ' + e.toString());
}

if (!localStorage) {
  throw new StorageError('localStorage is undefined');
}

storageWrapper = StorageFactory.create(localStorage, KEY);

/**
 * Wrapper for window.localStorage (multi key storage policy)
 * @returns {StorageInterface}
 */
exports.LocalStorage = storageWrapper;

/**
 * @param {string} key
 * @returns {boolean}
 *        True iff the key appears to be one that Optimizely owns.
 */
exports.isOptimizelyKey = function (key:string): boolean {
  return key.slice(0, KEY.length) === KEY;
};
